module.exports = __webpack_public_path__ + "img/sh1help.0c705259.png";